import React, { useEffect, useState } from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { GET_STARTED_URL } from '../../data/dgpt';
import { CtaButton } from '../ui/CtaButton';
import { cn } from '../../src/lib/utils';

/** Bottom CTA on small screens, revealed after the hero scrolls away. */
export function MobileStickyCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > window.innerHeight * 0.6);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <div className={cn('fixed inset-x-0 bottom-0 z-30 border-t border-hairline bg-ink/90 px-4 pb-[calc(env(safe-area-inset-bottom)+12px)] pt-3 backdrop-blur-xl transition-[transform,visibility] duration-300 motion-reduce:transition-none sm:hidden', visible ? 'visible translate-y-0' : 'invisible translate-y-full')} data-id="element-77" data-mp="25ru0ij4zh1u">
      <CtaButton href={GET_STARTED_URL} event="primary_cta_click" eventParams={{
      placement: 'mobile_sticky',
      cta: 'try_pitch_deck_screener'
    }} size="lg" className="w-full" data-id="element-78" data-mp="1cb5w6chdwnzd">
        Try Pitch Deck Screener
        <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-79" data-mp="1m0fqlyzpaiqn" />
      </CtaButton>
    </div>;
}